module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-21-da4abb017ec725ecebdfb3775cbea505.jpg";